import {
    ANNOTATION_VIDEO_DISPLAY,
    ANNOTATION_PARENT,
    VIDEO_PLAYING_MODE,
    ANNOTATION_LOCATION,
    VIDEO_SRC_TYPE
} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/lancaster-uni%2F2022%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "left";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "TROUBLESHOOTING";


const AnnotationsDB = [


    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h5></h5>`,
    //     bodyText: '',
    //       displayMesh: 'Y',
    //     // annotation_location: ANNOTATION_LOCATION.CENTER,
    //     useMeshButton: 'N',
    //     urlLink1Label: '',
    //     urlLink1: '',
    // },

    // iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],

    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iframeSource: '',
    //     headerText: `<h5></h5>`,
    //     bodyText: '',
    //     urlLink1Label: '',
    //     urlLink1: '',
    //       displayMesh: 'Y',
    //     // annotationParent: ANNOTATION_PARENT.PARENT_NONE,
    // },


    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     isMediaUsed: 'N',
    //     headerText: null,
    //     bodyText: null,
    //       displayMesh: 'Y',
    //     // ContactURL: '',
    // },

    /* Audios */
    // {
    //     paintingId: '',
    //     videoId: '',
    //     standaloneVideoElementId: '',
    //     videoURL: '.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
    //     displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
    //     headerText: ``,
    //     bodyText: null,
    //     displayMesh: 'Y',
    //     displayHeight: 90,
    //     videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
    //     displayAudioSprite: 'N',
    //     videoLoop: true,
    //     useVideoMeshButton: 'Y',
    // },
    /* Audios */




    /* Audios and Their Annotations */
    {
        paintingId: 'R07W11A119',
        videoId: 'R07W11A119',
        standaloneVideoElementId: 'R07W11A119',
        videoURL: 'R07W11A119.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A120',
        videoId: 'R07W11A120',
        standaloneVideoElementId: 'R07W11A120',
        videoURL: 'R07W11A120.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A121',
        videoId: 'R07W11A121',
        standaloneVideoElementId: 'R07W11A121',
        videoURL: 'R07W11A121.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A122',
        videoId: 'R07W11A122',
        standaloneVideoElementId: 'R07W11A122',
        videoURL: 'R07W11A122.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A123',
        videoId: 'R07W11A123',
        standaloneVideoElementId: 'R07W11A123',
        videoURL: 'R07W11A123.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A124',
        videoId: 'R07W11A124',
        standaloneVideoElementId: 'R07W11A124',
        videoURL: 'R07W11A124.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A125',
        videoId: 'R07W11A125',
        standaloneVideoElementId: 'R07W11A125',
        videoURL: 'R07W11A125.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A126',
        videoId: 'R07W11A126',
        standaloneVideoElementId: 'R07W11A126',
        videoURL: 'R07W11A126.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A127',
        videoId: 'R07W11A127',
        standaloneVideoElementId: 'R07W11A127',
        videoURL: 'R07W11A127.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: true,
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R07W11A119I01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h6>Podcasts from left to right</h6>`,
        bodyText: `<ol><li>Patrick Donnelly's Podcast on Ecological Regeneration</li><li>Katie Phillips' Podcast on Cultural Transformation in Architecture</li><li>Giles Bridge's Podcast on Cultural Transformation in Architecture</li><li>Bethan Jones' Podcast on Decarbonisation</li><li>Dan Mulhearn's Podcast on Decarbonisation</li><li>Betty Bowkett's Podcast on Cultural Transformation in Architecture</li><li>Waleed Akbar's Podcast on Ecological Regeneration</li><li>Elise Clarke's Podcast on Ecological Regeneration</li><li>Nadia Sharpe 's Podcast on Ecological Regeneration</li></ol>`,
        displayMesh: 'Y',
        annotation_location:ANNOTATION_LOCATION.TOP_LEFT,
    },
    /* Audios and Their Annotations */

    /* Videos */
    {
        paintingId: 'R01W03V003',
        videoId: 'R01W03V003',
        standaloneVideoElementId: 'R01W03V003',
        videoURL: 'R01W03V003.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
    },
    {
        paintingId: 'R02W02V005V01',
        videoId: 'R02W02V005V01',
        standaloneVideoElementId: 'R02W02V005V01',
        videoURL: 'R02W02V005V01.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R02W02V005V02',
        videoId: 'R02W02V005V02',
        standaloneVideoElementId: 'R02W02V005V02',
        videoURL: 'R02W02V005V02.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R02W02V005V03',
        videoId: 'R02W02V005V03',
        standaloneVideoElementId: 'R02W02V005V03',
        videoURL: 'R02W02V005V03.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R02W02V005V04',
        videoId: 'R02W02V005V04',
        standaloneVideoElementId: 'R02W02V005V04',
        videoURL: 'R02W02V005V04.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R02W02V005V05',
        videoId: 'R02W02V005V05',
        standaloneVideoElementId: 'R02W02V005V05',
        videoURL: 'R02W02V005V05.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R02W02V005V06',
        videoId: 'R02W02V005V06',
        standaloneVideoElementId: 'R02W02V005V06',
        videoURL: 'R02W02V005V06.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R02W02V005V07',
        videoId: 'R02W02V005V07',
        standaloneVideoElementId: 'R02W02V005V07',
        videoURL: 'R02W02V005V07.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R01W04V137V01',
        videoId: 'R01W04V137V01',
        standaloneVideoElementId: 'R01W04V137V01',
        videoURL: 'R01W04V137V01.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R01W04V137V02',
        videoId: 'R01W04V137V02',
        standaloneVideoElementId: 'R01W04V137V02',
        videoURL: '.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R01W04V137V03',
        videoId: 'R01W04V137V03',
        standaloneVideoElementId: 'R01W04V137V03',
        videoURL: 'R01W04V137V03.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
    },
    {
        paintingId: 'R07W02V106',
        videoId: 'R07W02V106',
        standaloneVideoElementId: 'R07W02V106',
        videoURL: 'R07W02V106.mp4',
        headerText: null,
        bodyText: null,
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        displayMesh: 'Y',
        videoAutoPlay: 'N',
        // videoTextureEncoding: THREE.sRGBEncoding,
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/97FF70EF-69A9-44AA-AB66-94C0A5B021E1',
    },
    /* Videos */

    /* ROOM 1 */
    {
        paintingId: 'R01W01T001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R01W01T001.jpg/info.json`,
        headerText: '<h5>School Diagram</h5>',
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R01W02P002',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R01W02P002.jpg/info.json`,
        headerText: '<h5>Course Diagram + Exhbition Intro</h5>',
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: '',
        urlLink1: '',
    },
    /* ROOM 1 */

    /* ROOM 2 */
    {
        paintingId: 'R02W01T004',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R02W01T004.jpg/info.json`,
        headerText: '<h5>TEA Talks Logo and Description</h5>',
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R02W03T006',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R02W03T006.jpg/info.json`,
        headerText: '<h5></h5>',
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: '',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        headerText: '<h5></h5>',
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: '',
        urlLink1: '',
    },
    /* ROOM 2 */

    /* ROOM 3 */
    {
        paintingId: 'R03W01T007',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W01T007.jpg/info.json`,
        headerText: '<h5>ARCH101 Module Introduction</h5>',
        bodyText: null,
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W01T008',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W01T008.jpg/info.json`,
        headerText: '<h5>ARCH101-P1 Project Introduction</h5>',
        bodyText: null,
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W01P009',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W01P009.jpg/info.json`,
        headerText: `<h5>ARCH101_P1 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W01P010',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W01P010.jpg/info.json`,
        headerText: `<h5>ARCH101_P1 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W01P011',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W01P011.jpg/info.json`,
        headerText: `<h5>ARCH101_P1 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W01P012',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W01P012.jpg/info.json`,
        headerText: `<h5>ARCH101_P1 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W01P013',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W01P013.jpg/info.json`,
        headerText: `<h5>ARCH101_P1 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W01P014',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W01P014.jpg/info.json`,
        headerText: `<h5>ARCH101_P1 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02T015',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02T015.jpg/info.json`,
        headerText: `<h5>ARCH101-P2 Project Introduction</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P016',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P016.jpg/info.json`,
        headerText: `<h5>ARCH101_P2 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P017',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P017.jpg/info.json`,
        headerText: `<h5>ARCH101_P2 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P018',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P018.jpg/info.json`,
        headerText: `<h5>ARCH101_P2 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P019',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P019.jpg/info.json`,
        headerText: `<h5>ARCH101_P2 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02T020',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02T020.jpg/info.json`,
        headerText: `<h5>ARCH101-P3 Project Introduction</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P021',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P021.jpg/info.json`,
        headerText: `<h5>ARCH101_P3 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P022',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P022.jpg/info.json`,
        headerText: `<h5>ARCH101_P3 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P023',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P023.jpg/info.json`,
        headerText: `<h5>ARCH101_P3 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P024',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P024.jpg/info.json`,
        headerText: `<h5>ARCH101_P3 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P025',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P025.jpg/info.json`,
        headerText: `<h5>ARCH101_P3 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W02P026',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W02P026.jpg/info.json`,
        headerText: `<h5>ARCH101_P3 2021/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W03T027',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W03T027.jpg/info.json`,
        headerText: `<h5>ARCH102 Module Introduction</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04T028',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04T028.jpg/info.json`,
        headerText: `<h5>ARCH102-P1 Project Introduction</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P029',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P029.jpg/info.json`,
        headerText: `<h5>ARCH102_P1 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P030',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P030.jpg/info.json`,
        headerText: `<h5>ARCH102_P1 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P031',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P031.jpg/info.json`,
        headerText: `<h5>ARCH102_P1 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P032',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P032.jpg/info.json`,
        headerText: `<h5>ARCH102_P1 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04T033',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04T033.jpg/info.json`,
        headerText: `<h5>ARCH102-P2 Project Introduction</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P034',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P034.jpg/info.json`,
        headerText: `<h5>ARCH102_P2 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P035',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P035.jpg/info.json`,
        headerText: `<h5>ARCH102_P2 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P036',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P036.jpg/info.json`,
        headerText: `<h5>ARCH102_P2 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P037',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P037.jpg/info.json`,
        headerText: `<h5>ARCH102_P2 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P038',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P038.jpg/info.json`,
        headerText: `<h5>ARCH102_P2 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W04P039',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W04P039.jpg/info.json`,
        headerText: `<h5>ARCH102_P2 2020/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R03W05T041',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W05T041.jpg/info.json`,
        headerText: `<h5>ARCH101-P1 pdf (big Axo)</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/2907DC39-1516-468C-9DD8-F41E18489894',
    },
    {
        paintingId: 'R03W05T042',
        videoId: null,
        videoURL: null,
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}R03W05T042.jpg/info.json`,
        iframeSource: 'https://e.issuu.com/embed.html?d=r03w05t042&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>YEAR 1 - Wire Models</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        // urlLink1Label: '',
        // urlLink1: '',
    },
    {
        paintingId: 'R03W05T043',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}R03W05T043.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}R03W05T043P01.jpg/info.json`],
        headerText: `<h5>ARCH101-P1 pdf - 20-21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: '',
        urlLink1: '',
    },
    {
        paintingId: 'R03W05T040',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r03w05t040&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH101-P1 pdf (pictures plaster models)</h5>`,
        bodyText: '',
        // urlLink1Label: 'Link to 3D Model',
        // urlLink1: 'https://poly.cam/capture/2907DC39-1516-468C-9DD8-F41E18489894',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R03W05T044',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r03w05t044&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH101-P2 pdf - 20-21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R03W05T045',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r03w05t045&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH101-P3 pdf - 20-21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R03W05T046',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r03w05t046&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH101-P4 pdf - 20-21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R03W05T047',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r03w05t047&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH101-P5 pdf - 20-21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    /* ROOM 3 */

    /* ROOM 4 */
    {
        paintingId: 'R04W01T048',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R04W01T048.jpg/info.json`,
        headerText: `<h5>Description - intro text</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R04W01P049',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R04W01P049.jpg/info.json`,
        headerText: `<h5>Photographs - Week's Mood</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R04W02P050',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R04W02P050.jpg/info.json`,
        headerText: `<h5>Willow Workshop</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R04W02P051',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R04W02P051.jpg/info.json`,
        headerText: `<h5>Timber Bridge </h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R04W05P052',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R04W05P052.jpg/info.json`,
        headerText: `<h5>Trusses Workshop</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R04W05P053',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R04W05P053.jpg/info.json`,
        headerText: `<h5>Parametric Facade Workshop</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    /* ROOM 4 */

    /* ROOM 5 */
    {
        paintingId: 'R05W01P054',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W01P054.jpg/info.json`,
        headerText: `<h5>Bouyant Community Housing Project - Dan Mulhearn - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W01P055',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W01P055.jpg/info.json`,
        headerText: `<h5>Aerial Living - Nadia Sharpe - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W01P056',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W01P056.jpg/info.json`,
        headerText: `<h5>Floating Communities - Ross Bland - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W02P057',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W02P057.jpg/info.json`,
        headerText: `<h5>A Knock on the Door - Charlotte Pugh - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W06P058',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W06P058.jpg/info.json`,
        headerText: `<h5>The Cove - Patrick Donnelly - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W07P059',
        videoId: null,
        videoURL: null,
        //iiif-images swap under client's request
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W07P059.jpg/info.json`,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W08P060.jpg/info.json`,
        headerText: `<h5>Co-Living Artists Community - Giles Bridge - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W08P060',
        videoId: null,
        videoURL: null,
        //iiif-images swap under client's request
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W08P060.jpg/info.json`,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W07P059.jpg/info.json`,
        headerText: `<h5>An Active Community: Parkour and Play - Katie Phillips - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W09P061',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W09P061.jpg/info.json`,
        headerText: `<h5>A Walled Garden - Waleed Akbar - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W04T065',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W04T065.jpg/info.json`,
        headerText: `<h5>Introduction to Second Year Design Modules</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W05P066',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W05P066.jpg/info.json`,
        headerText: `<h5>A Bouyant Community Masterplan & Manifesto - Group Work - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W05P067',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W05P067.jpg/info.json`,
        headerText: `<h5>The Playground of Life Masterplan & Manifesto- Group Work - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W05P068',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W05P068.jpg/info.json`,
        headerText: `<h5>The Future of Connectivity Masterplan & Manifesto - Group Work - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W05P069',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R05W05P069.jpg/info.json`,
        headerText: `<h5>Cycle City Masterplan & Manifesto - Group Work - ARCH201 Semester One</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R05W10P062',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}R05W10P062.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}R05W10P062P01.jpg/info.json`],
        headerText: `<h5>Second Year - Housing Project Model</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/F99B7D6E-4A15-48AD-AF18-8716DFEF5127',
    },
    {
        paintingId: 'R05W10P063',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}R05W10P063.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}R05W10P063P01.jpg/info.json`],
        headerText: `<h5>Second Year - Housing Project Model</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/85337ACE-011F-4F7F-9C48-FF7047C19B4F',
    },
    {
        paintingId: 'R05W10P064',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}R05W10P064.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}R05W10P064P01.jpg/info.json`],
        headerText: `<h5>Second Year - Housing Project Model</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/0C2DD619-D02D-4785-A98B-94B6BB2ECAEB',
    },
    /* ROOM 5 */

    /* ROOM 6 */
    {
        paintingId: 'R06W01T070',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W01T070.jpg/info.json`,
        headerText: `<h5>Solar Shading Device - Bailrigg House Facade Model - Introduction</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W01P071',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W01P071.jpg/info.json`,
        headerText: `<h5>ARCH 203 Semester One - Building Regulations Case Study - Analysis</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W01P072',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W01P072.jpg/info.json`,
        headerText: `<h5>ARCH 203 Semester One - Building Regulations Case Study - Analysis</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W01P073',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W01P073.jpg/info.json`,
        headerText: `<h5>ARCH 203 Semester One - Building Regulations Case Study - FIre & Escape Distances</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W01P074',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W01P074.jpg/info.json`,
        headerText: `<h5>ARCH 203 Semester One - 3D Model of Hertfordshire Student Accomodation</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W01P075',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W01P075.jpg/info.json`,
        headerText: `<h5>ARCH 203 Semester One - FIre Stopping Section Locations - Case Studies</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W01P076',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W01P076.jpg/info.json`,
        headerText: `<h5>ARCH 203 Semester One - 3D Model of Hertfordshire - External Utility Stair</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W02T077',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W02T077.jpg/info.json`,
        headerText: `<h5>Year One Technology - Introduction - ARCH103</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W02P078',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W02P078.jpg/info.json`,
        headerText: `<h5>ARCH103 Semester One - LICA Building Case Study</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W02P079',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W02P079.jpg/info.json`,
        headerText: `<h5>ARCH103 Semester One - LICA Building Case Study</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W02P080',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W02P080.jpg/info.json`,
        headerText: `<h5>ARCH103 Semester One - LICA Building Case Study</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W02P081',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W02P081.jpg/info.json`,
        headerText: `<h5>ARCH103 Semester One - Seminar Detail Drawing Exercises</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W02P082',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W02P082.jpg/info.json`,
        headerText: `<h5>ARCH103 Semester One & Two - Seminar Stucture and Environment Analysis</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W02P083',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W02P083.jpg/info.json`,
        headerText: `<h5>ARCH103 Semester Two - Carbon Calculation and Comfort Analysis</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W04T088',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W04T088.jpg/info.json`,
        headerText: `<h5>Year Two Technology - Introduction - ARCH203</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W04P089',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W04P089.jpg/info.json`,
        headerText: `<h5>ARCH 203 - Solar Shading Device - Analysis of Shadow and Shading Coverage</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W04P090',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W04P090.jpg/info.json`,
        headerText: `<h5>ARCH 203 - Model Photos - Solar Shading Device for Bailrigg House</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W04P091',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W04P091.jpg/info.json`,
        headerText: `<h5>ARCH 203 - Model Photos - Solar Shading Device for Bailrigg House</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W04P092',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W04P092.jpg/info.json`,
        headerText: `<h5>ARCH 203 - Model Photos - Solar Shading Device for Bailrigg House</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W04P093',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W04P093.jpg/info.json`,
        headerText: `<h5>ARCH 203 - Model Photos - Solar Shading Device for Bailrigg House</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W04P094',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W04P094.jpg/info.json`,
        headerText: `<h5>ARCH 203 - Model Photos - Solar Shading Device for Bailrigg House</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W04P095',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R06W04P095.jpg/info.json`,
        headerText: `<h5>ARCH 203 - Model Photos - Solar Shading Device for Bailrigg House</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R06W03M084',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}R06W03M084.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}R06W03M084P01.jpg/info.json`],
        headerText: `<h5>ARCH 203 - Solar Shading Device Physcial Model</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/00660993-30A3-40D3-987B-6512BFE0450D',
    },
    {
        paintingId: 'R06W03M085',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}R06W03M085.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}R06W03M085P01.jpg/info.json`],
        headerText: `<h5>ARCH 203 - Solar Shading Device Physcial Model</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/E90F0D19-DD1A-4BDC-B390-81709D8D1C31',
    },
    {
        paintingId: 'R06W03M086',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}R06W03M086.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}R06W03M086P01.jpg/info.json`],
        headerText: `<h5>ARCH 203 - Solar Shading Device Physcial Model</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/8B62D1FA-0A0C-493E-A755-4EDFC31B9F76',
    },
    {
        paintingId: 'R06W03M087',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}R06W03M087.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}R06W03M087P01.jpg/info.json`],
        headerText: `<h5>ARCH 203 - Solar Shading Device Physcial Model</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/7D437682-9F21-4B53-B873-95EF8EEC5284',
    },
    {
        paintingId: 'R06W05T096',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r06w05t096&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH 103 - First Year Technology - Sample of Module Work 20/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R06W05T097',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r06w05t097&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH 103 - First Year Technology - Sample of Module Work 20/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R06W05T098',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r06w05t098&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH 103 - First Year Technology - Sample of Module Work 20/21</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R06W05T099',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r06w05t099&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH 203 - Second Year Technology - Semester One - Sample of Module Work 21/22</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R06W05T100',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r06w05t100&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH 203 - Second Year Technology - Semester One - Sample of Module Work 21/23</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R06W05T101',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r06w05t101&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>ARCH 203 - Second Year Technology - Semester One - Sample of Module Work 21/24</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    /* ROOM 6 */

    /* ROOM 7 */
    {
        paintingId: 'R07W01T102',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W01T102.jpg/info.json`,
        headerText: `<h5>Humanities Introduction</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R07W01T103',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W01T103.jpg/info.json`,
        headerText: `<h5>Intro text: Game Boards</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R07W01P104',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W01P104.jpg/info.json`,
        headerText: `<h5>Game Boards</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/97FF70EF-69A9-44AA-AB66-94C0A5B021E1',
    },
    {
        paintingId: 'R07W01P105',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W01P105.jpg/info.json`,
        headerText: `<h5>Game Boards</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
        urlLink1Label: 'Link to 3D Model',
        urlLink1: 'https://poly.cam/capture/97FF70EF-69A9-44AA-AB66-94C0A5B021E1',
    },
    {
        paintingId: 'R07W03T107',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W03T107.jpg/info.json`,
        headerText: `<h5>Intro Text: Timeline Posters</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R07W03P108',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W03P108.jpg/info.json`,
        headerText: `<h5>Timeline Posters</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R07W03P109',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W03P109.jpg/info.json`,
        headerText: `<h5>Timeline Posters</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R07W04T110',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W04T110.jpg/info.json`,
        headerText: `<h5>Intro Text: People's Observations</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R07W04P111',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W04P111.jpg/info.json`,
        headerText: `<h5>People's Observations</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R07W04P112',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R07W04P112.jpg/info.json`,
        headerText: `<h5>People's Observations</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R07W10T113',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r07w10t113&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>Waleed Akbar's Essay on "Function"</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R07W10T114',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r07w10t114&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>Katie Phillips' Essay on "Truth"</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R07W10T115',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r07w10t115&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>Bethan Jones' Essay on "Memory"</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R07W10T116',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r07w10t116&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>Betty Bowkett's Essay on "Place"</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R07W10T117',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r07w10t117&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>Ayo Odedena's Essay on "Memory"</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    {
        paintingId: 'R07W10T118',
        videoId: null,
        videoURL: null,
        iframeSource: 'https://e.issuu.com/embed.html?d=r07w10t118&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h5>Lucie Tulip's Essay on "Function"</h5>`,
        bodyText: '',
        displayMesh: 'Y',
    },
    /* ROOM 7 */

    /* ROOM 8 */
    {
        paintingId: 'R08W03T128',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W03T128.jpg/info.json`,
        headerText: `<h5>Prizes Description</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R08W03P129',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W03P129.jpg/info.json`,
        headerText: `<h5>Prizes 2020/21 - 1</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R08W03P130',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W03P130.jpg/info.json`,
        headerText: `<h5>Prizes 2020/21 - 2</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R08W03P131',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W03P131.jpg/info.json`,
        headerText: `<h5>Prizes 2020/21 - 3</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R08W03P132',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W03P132.jpg/info.json`,
        headerText: `<h5>Prizes 2020/21 - 4</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R08W04T133',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W04T133.jpg/info.json`,
        headerText: `<h5>ARCHIextra description</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R08W04P134',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W04P134.jpg/info.json`,
        headerText: `<h5>ARCHIextra posters (with a link to a pdf)</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R08W02P135',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W02P135.jpg/info.json`,
        headerText: `<h5>Students Society</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    {
        paintingId: 'R08W01P136',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}R08W01P136.jpg/info.json`,
        headerText: `<h5>School Picture</h5>`,
        bodyText: '',
        displayMesh: 'Y',
        useMeshButton: 'N',
    },
    /* ROOM 8 */

];

export {AnnotationsDB};
